import { useAuthStore } from 'features/auth/stores/authStore';

import { apiClient } from '../client/apiClient';
import { ENDPOINTS } from '../config/endpoints';
import type { Client, CreateClientDto, UpdateClientDto } from '../types/client.types';
import type { ApiResponse } from '../types/common.types';

const getWorkspaceId = (): string => {
  const workspaceId = useAuthStore.getState().user?.workspaceId;
  if (!workspaceId) throw new Error('No active workspace');
  return workspaceId;
};

export const clientService = {
  getClients: () => {
    const wid = getWorkspaceId();
    return apiClient.get<ApiResponse<Client[]>>(ENDPOINTS.CLIENTS.LIST(wid));
  },

  getClient: (id: string) => {
    const wid = getWorkspaceId();
    return apiClient.get<ApiResponse<Client>>(ENDPOINTS.CLIENTS.DETAIL(wid, id));
  },

  createClient: (data: CreateClientDto) => {
    const wid = getWorkspaceId();
    return apiClient.post<ApiResponse<{ id: string }>>(ENDPOINTS.CLIENTS.CREATE(wid), data);
  },

  updateClient: (id: string, data: UpdateClientDto) => {
    const wid = getWorkspaceId();
    return apiClient.put<ApiResponse<void>>(ENDPOINTS.CLIENTS.UPDATE(wid, id), data);
  },

  deleteClient: (id: string) => {
    const wid = getWorkspaceId();
    return apiClient.delete<ApiResponse<void>>(ENDPOINTS.CLIENTS.DELETE(wid, id));
  },
};
